import { LOCATION_TABS, LOCATION_DETAILS } from 'texts/locationDetails'
import { OriginButton, FormContext } from '@frontend/design_system'
import { ContactInformationBlock } from '../ContactInformationBlock'
import { WorkingHoursBlock } from '../WorkingHoursBlock'
import { useCheckRequiredFields } from 'hooks/useCheckRequiredFields'
import { ReservationBlock } from '../ReservationBlock'
import { WaitingHoursBlock } from '../WaitingHoursBlock'
import { RightSideProps } from './types'
import { REQUIRED_FIELDS } from '../../constants'
import styles from './styles.module.scss'
import { useMemo } from 'react'

export const RightSide = ({
  formValues,
  activeKey,
  workingHours,
  isLoading,
  isEditing,
}: RightSideProps) => {
  const { isDisabledFormButton } = useCheckRequiredFields(
    REQUIRED_FIELDS,
    FormContext
  )

  const renderInfoContent = (formValues: Record<string, unknown>) => {
    if (activeKey === LOCATION_TABS.INFORMATION) {
      return <ContactInformationBlock values={formValues} />
    }
    if (activeKey === LOCATION_TABS.WORKING_HOURS) {
      return <WorkingHoursBlock workingHours={workingHours} />
    }
    if (activeKey === LOCATION_TABS.RESERVATION) {
      return <ReservationBlock values={formValues} />
    }
    if (activeKey === LOCATION_TABS.WAITING_HOURS) {
      return <WaitingHoursBlock values={formValues} />
    }
  }

  const isWorkingHourExist = useMemo(
    () => workingHours.some((el) => el.dayStart && el.dayEnd),
    [workingHours]
  )

  return (
    <div className={styles.container}>
      {renderInfoContent(formValues)}
      <div className={styles['button-wrapper']}>
        {!isEditing && (
          <OriginButton
            htmlType="submit"
            loading={isLoading}
            label={LOCATION_DETAILS.BUTTONS.ADD_LOCATION_LABEL}
            disabled={isDisabledFormButton || !isWorkingHourExist}
            size="large"
          />
        )}
      </div>
    </div>
  )
}
